export const endpoints = {
  auth: '/auths',
  createOAuth: '/auths/create-oauth',
  loginOAuth: '/auths/oauth-login',
  loginGoogle: '/auths/login/google',
  completeGoogleSignup: '/auths/google/complete-signup',
  business: '/businesses',
  businessMe: '/businesses/me',
  businessVerify: '/businesses/verify',
  login: '/auths/login',
  logout: '/auths/logout',
  products: '/products',
  productsBulkUpload: '/products/bulk-upload',
  productsBulkUploadDraft: '/products/bulk-upload/draft',
  productsBulkUploadValidate: '/products/bulk-upload/validate',
  productsBulkUploadExtract: '/products/bulk-upload/extract',
  categories: '/categories',
  subcategories: '/subcategories',
  resetPassword: '/auths/reset-password',
  changePassword: '/auths/change-password',
  requestOTP: '/verification-codes',
  stores: '/stores',
  checkDomain: '/stores/check-domain',
  /** Buy a new domain through Sellyt. */
  domainSearch: '/stores/me/domains/search',
  domainPurchase: '/stores/me/domains/purchase',
  /** Connect / verify / remove an owned domain. */
  storeCustomDomain: '/stores/me/custom-domain',
  storeCustomDomainVerify: '/stores/me/custom-domain/verify',
  uploads: '/uploads',
  user: '/users',
  updatePhoneRequest: '/users/me/phone/request',
  confirmPhoneUpdate: '/users/me/phone/confirm',
  updateEmailRequest: '/users/me/email/request',
  confirmEmailUpdate: '/users/me/email/confirm',
  settlementAccountRequest: '/users/me/settlement-account/request',
  settlementAccountConfirm: '/users/me/settlement-account/confirm',

  verifyOTP: '/verification-codes/verify-otp',
  orders: '/orders',
  shipping: '/shipping-methods',
  pickupLocations: '/pickup-locations',
  twoFactor: {
    setup: '/auths/setup-2fa',
    verify: '/auths/verify-2fa',
    initializeDisable: '/auths/initialize-disable-2fa',
    disable: '/auths/disable-2fa',
  },
  analytics: {
    sales: '/analytics/sales',
    transactions: '/analytics/transactions',
    products: '/analytics/products',
    customers: '/analytics/customers',
    dashboard: '/analytics/dashboard',
    recentChats: '/analytics/dashboard/recent-chats',
  },
  omnichannel: {
    accounts: '/omnichannel/accounts',
    conversations: '/omnichannel/conversations',
    /** POST — `/omnichannel/conversations/:id/mark-read` */
    conversationMarkRead: (conversationId: string) =>
      `/omnichannel/conversations/${conversationId}/mark-read`,
    messages: '/omnichannel/messages',
    /** GET — WhatsApp media proxy: `/omnichannel/media/{content}?conversationId=` */
    media: '/omnichannel/media',
    connect: '/omnichannel/connect',
    /** POST `{ code, wabaId }` — existing WhatsApp Business App number (coexistence). */
    connectWhatsappCoexistence: '/omnichannel/connect/whatsapp/coexistence',
    disconnect: '/omnichannel/disconnect',
    status: '/omnichannel/status',
    /** POST body: `{ message, conversationId }` — AI reply is pushed on `new_message` (`type: ai_response`). */
    aiTest: '/omnichannel/test/ai',
    /** Stop AI service run (adjust path to match your API). */
    aiStop: '/omnichannel/test/ai/stop',
  },
  whatsappTemplates: '/whatsapp-templates',
  whatsappTemplate: (id: number | string) => `/whatsapp-templates/${id}`,
  whatsappTemplatesSync: '/whatsapp-templates/sync',
  support: {
    tickets: '/support-tickets',
    articles: '/articles',
    /** GET — current user's AI support conversation. */
    chatConversation: '/ai-support/conversation',
    /** POST — send `{ message }`; assistant reply arrives on Socket.IO `new_message`. */
    chatMessages: '/ai-support/messages',
  },
  transactions: '/transactions',
  banks: '/subscriptions/banks',
  resolveAccount: '/subscriptions/resolveAccount',
  notifications: '/notifications',
  notificationUnreadCount: '/notifications/unread-count',
  notificationReadAll: '/notifications/read-all',
  notificationSettings: '/notifications/settings',
  billingHistory: '/subscriptions/billing-history',
  subscriptionPlans: '/subscriptions/plans',
  subscriptionBusiness: '/subscriptions/business',
  subscribe: '/subscriptions/subscribe',
  cancelSubscription: '/subscriptions/cancel',
  referrals: {
    me: '/referrals/me',
    meCode: '/referrals/me/code',
    activity: '/referrals/activity',
    history: '/referrals/history',
    earnings: '/referrals/earnings',
    withdraw: '/referrals/withdraw',
    applySubscriptionCredit: '/referrals/apply-subscription-credit',
  },
  chatbot: {
    settings: '/chatbot/settings',
  },
};
